import ApiService from '@/common/api.service'

export default {
  getHistory (ankenId) {
    return new Promise((resolve, reject) => {
      ApiService.query(`/chat/history/client/${ankenId}`).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getHistoryByConversationId (conversationId) {
    return new Promise((resolve, reject) => {
      ApiService.query(`/chat/history/${conversationId}`).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getListConversation (ankenId) {
    return new Promise((resolve, reject) => {
      ApiService.query(`/chat/conversations/${ankenId}`).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  sendMessage (message, ankenId) {
    return new Promise((resolve, reject) => {
      ApiService.post(`/chat/send-message/client/${ankenId}`, message).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  sendMessageByConversationId (message, conversationId) {
    return new Promise((resolve, reject) => {
      ApiService.post(`/chat/send-message/${conversationId}`, message).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

    createConversationByAdmin (memberId, ankenId) {
        return new Promise((resolve, reject) => {
            ApiService.post('/chat/admin/conversations', { memberId, ankenId }).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },

    deleteMessage (messageId) {
        return new Promise((resolve, reject) => {
            ApiService.post('/chat/delete-message/' + messageId).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
